(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aroma-carrusel"] && !Shopify.designMode) return;
  try {
    
  function arrancarCarruselesAroma(raiz) {
    (raiz || document).querySelectorAll('[data-car-via]').forEach((via) => {
      if (via.dataset.carListo) return;
      via.dataset.carListo = '1';

      const seccion = via.closest('.aroma-car');
      const prev = seccion.querySelector('[data-car-prev]');
      const next = seccion.querySelector('[data-car-next]');
      const celda = via.querySelector('.aroma-car__celda');
      if (!prev || !next || !celda) return;

      const paso = () => celda.getBoundingClientRect().width + 16;

      const estado = () => {
        const fin = via.scrollWidth - via.clientWidth - 2;
        prev.disabled = via.scrollLeft <= 2;
        next.disabled = via.scrollLeft >= fin;
      };

      prev.addEventListener('click', () => via.scrollBy({ left: -paso() * 2 }));
      next.addEventListener('click', () => via.scrollBy({ left: paso() * 2 }));
      via.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancarCarruselesAroma());
  } else {
    arrancarCarruselesAroma();
  }
  document.addEventListener('shopify:section:load', (e) => arrancarCarruselesAroma(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aroma-otras"] && !Shopify.designMode) return;
  try {
    
  class CascadaAroma {
    constructor(nodo) {
      this.nodo = nodo;
      this.cartas = Array.from(nodo.querySelectorAll('[data-carta]'));
      if (this.cartas.length < 2) {
        this.cartas.forEach((c) => c.setAttribute('data-frente', ''));
        return;
      }

      const raiz = nodo.closest('.aroma-otras');
      this.raiz = raiz;
      this.actualEl = raiz.querySelector('[data-cascada-actual]');
      this.orden = this.cartas.slice();
      this.bloqueado = false;

      const ms = parseInt(getComputedStyle(raiz).getPropertyValue('--caida'), 10);
      this.duracion = Number.isFinite(ms) ? ms : 900;

      raiz.querySelector('[data-cascada-next]')?.addEventListener('click', () => {
        this.parar();
        this.siguiente();
      });

      this.pintar();
      this.quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.quieto) this.arrancar();

      // se detiene mientras el visitante está encima o navegando con teclado
      nodo.addEventListener('pointerenter', () => this.parar());
      nodo.addEventListener('pointerleave', () => this.arrancar());
      nodo.addEventListener('focusin', () => this.parar());
      nodo.addEventListener('focusout', () => this.arrancar());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.parar(); else this.arrancar();
      });
    }

    arrancar() {
      if (this.quieto || this.temporizador) return;
      const espera = Math.max(2200, this.duracion + 2200);
      this.temporizador = window.setInterval(() => this.siguiente(), espera);
    }

    parar() {
      window.clearInterval(this.temporizador);
      this.temporizador = null;
    }

    pintar() {
      this.orden.forEach((carta, i) => {
        carta.style.setProperty('--i', i);
        if (i > 3) carta.setAttribute('data-oculta', '');
        else carta.removeAttribute('data-oculta');
        if (i === 0) {
          carta.setAttribute('data-frente', '');
          carta.removeAttribute('tabindex');
        } else {
          carta.removeAttribute('data-frente');
          carta.setAttribute('tabindex', '-1');
        }
      });
      if (this.actualEl) {
        const pos = this.cartas.indexOf(this.orden[0]) + 1;
        this.actualEl.textContent = String(pos).padStart(2, '0');
      }
    }

    siguiente() {
      if (this.bloqueado) return;
      this.bloqueado = true;
      const frente = this.orden[0];
      frente.setAttribute('data-cae', '');

      window.setTimeout(() => {
        this.orden.push(this.orden.shift());
        frente.removeAttribute('data-cae');
        frente.style.transition = 'none';
        this.pintar();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          frente.style.transition = '';
          this.bloqueado = false;
        }));
      }, this.duracion);
    }
  }

  function arrancarCascadas(raiz) {
    (raiz || document).querySelectorAll('[data-cascada]').forEach((nodo) => {
      if (nodo.dataset.cascadaLista) return;
      nodo.dataset.cascadaLista = '1';
      new CascadaAroma(nodo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancarCascadas());
  } else {
    arrancarCascadas();
  }
  document.addEventListener('shopify:section:load', (e) => arrancarCascadas(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aroma-pila"] && !Shopify.designMode) return;
  try {
    
  class PilaAroma {
    constructor(nodo) {
      this.nodo = nodo;
      this.cartas = Array.from(nodo.querySelectorAll('[data-carta]'));
      if (this.cartas.length === 0) return;

      const raiz = nodo.closest('.aroma-pila');
      this.actualEl = raiz.querySelector('[data-pila-actual]');
      this.totalEl = raiz.querySelector('[data-pila-total]');
      this.orden = this.cartas.slice();
      this.bloqueado = false;

      if (this.totalEl) this.totalEl.textContent = String(this.cartas.length).padStart(2, '0');

      raiz.querySelector('[data-pila-prev]')?.addEventListener('click', () => this.anterior());
      raiz.querySelector('[data-pila-next]')?.addEventListener('click', () => this.siguiente());

      nodo.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.siguiente(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.anterior(); }
      });

      this.arrastre(nodo);
      this.anclarListado(raiz);
      this.pintar();
    }

    // Shopify prefija los id de sección con template--<n>__, así que el ancla
    // se resuelve buscando el sufijo en vez de fiarse de un id fijo.
    anclarListado(raiz) {
      const enlace = raiz.querySelector('[data-pila-anclaje]');
      if (!enlace) return;
      const clave = enlace.dataset.pilaAnclaje;
      const destino = document.getElementById(clave) || document.querySelector('[id$="__' + clave + '"]');
      if (!destino) return;

      enlace.setAttribute('href', '#' + destino.id);
      enlace.addEventListener('click', (e) => {
        e.preventDefault();
        const suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        destino.scrollIntoView({ behavior: suave, block: 'start' });
      });
    }

    // Un deslizamiento solo cuenta si es corto en el tiempo y claramente
    // horizontal. Si no, el scroll vertical del móvil pasaría las cartas.
    arrastre(nodo) {
      let inicio = null;

      nodo.addEventListener('pointerdown', (e) => {
        if (!e.isTrusted || e.target.closest('a, button')) return;
        inicio = { x: e.clientX, y: e.clientY, id: e.pointerId, t: Date.now() };
      });

      nodo.addEventListener('pointerup', (e) => {
        if (!inicio || e.pointerId !== inicio.id) return;
        const dx = e.clientX - inicio.x;
        const dy = e.clientY - inicio.y;
        const ms = Date.now() - inicio.t;
        inicio = null;

        if (ms > 800) return;
        if (Math.abs(dx) < 60) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.5) return;

        if (dx < 0) this.siguiente();
        else this.anterior();
      });

      nodo.addEventListener('pointercancel', () => { inicio = null; });
      nodo.addEventListener('pointerleave', () => { inicio = null; });
    }

    pintar() {
      this.orden.forEach((carta, i) => {
        carta.style.setProperty('--i', i);
        if (i > 3) carta.setAttribute('data-oculta', '');
        else carta.removeAttribute('data-oculta');
        if (i === 0) carta.setAttribute('data-frente', '');
        else carta.removeAttribute('data-frente');
        carta.querySelectorAll('a').forEach((a) => {
          if (i === 0) a.removeAttribute('tabindex');
          else a.setAttribute('tabindex', '-1');
        });
      });
      if (this.actualEl) this.actualEl.textContent = String(1).padStart(2, '0');
    }

    // Cada avance mueve la de delante al final. El contador cuenta cuántas has pasado.
    siguiente() {
      if (this.bloqueado || this.orden.length < 2) return;
      this.bloqueado = true;
      const frente = this.orden[0];
      frente.setAttribute('data-cae', '');

      window.setTimeout(() => {
        this.orden.push(this.orden.shift());
        frente.removeAttribute('data-cae');
        frente.style.transition = 'none';
        this.pintar();
        this.vista();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          frente.style.transition = '';
          this.bloqueado = false;
        }));
      }, 520);
    }

    anterior() {
      if (this.bloqueado || this.orden.length < 2) return;
      this.bloqueado = true;
      const ultima = this.orden[this.orden.length - 1];
      ultima.style.transition = 'none';
      ultima.setAttribute('data-cae', '');

      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.orden.unshift(this.orden.pop());
        ultima.style.transition = '';
        ultima.removeAttribute('data-cae');
        this.pintar();
        this.vista();
        window.setTimeout(() => { this.bloqueado = false; }, 420);
      }));
    }

    vista() {
      if (!this.actualEl) return;
      const pos = this.cartas.indexOf(this.orden[0]) + 1;
      this.actualEl.textContent = String(pos).padStart(2, '0');
    }
  }

  function arrancarPilas(raiz) {
    (raiz || document).querySelectorAll('[data-pila]').forEach((nodo) => {
      if (nodo.dataset.pilaLista) return;
      nodo.dataset.pilaLista = '1';
      new PilaAroma(nodo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancarPilas());
  } else {
    arrancarPilas();
  }
  document.addEventListener('shopify:section:load', (e) => arrancarPilas(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aroma-video"] && !Shopify.designMode) return;
  try {
    
  function arrancarVideosAroma(raiz) {
    (raiz || document).querySelectorAll('[data-video]').forEach((marco) => {
      if (marco.dataset.videoListo) return;
      marco.dataset.videoListo = '1';

      const media = marco.querySelector('video');
      const boton = marco.querySelector('[data-video-toggle]');
      if (!media || !boton) return;

      const iPausa = boton.querySelector('[data-icono-pausa]');
      const iPlay = boton.querySelector('[data-icono-play]');

      const pintar = () => {
        const parado = media.paused;
        iPausa.hidden = parado;
        iPlay.hidden = !parado;
        boton.setAttribute('aria-label', parado ? boton.dataset.reproducir : boton.dataset.pausar);
      };

      boton.addEventListener('click', () => {
        if (media.paused) media.play(); else media.pause();
        pintar();
      });
      media.addEventListener('play', pintar);
      media.addEventListener('pause', pintar);

      // Quien pide menos movimiento no debería recibir un vídeo en bucle.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        media.removeAttribute('autoplay');
        media.pause();
      }

      // Fuera de pantalla no se reproduce: ahorra batería y datos.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entradas) => {
          entradas.forEach((e) => {
            if (media.dataset.pausadoAMano === '1') return;
            if (e.isIntersecting) media.play().catch(() => {});
            else media.pause();
          });
        }, { threshold: 0.15 });
        io.observe(marco);
      }

      boton.addEventListener('click', () => {
        media.dataset.pausadoAMano = media.paused ? '1' : '0';
      });

      pintar();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancarVideosAroma());
  } else {
    arrancarVideosAroma();
  }
  document.addEventListener('shopify:section:load', (e) => arrancarVideosAroma(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-aromas"] && !Shopify.designMode) return;
  try {
    
  function arrancarAromas(raiz) {
    (raiz || document).querySelectorAll('[data-aromas-via]').forEach((via) => {
      if (via.dataset.aromasListo) return;
      via.dataset.aromasListo = '1';

      const seccion = via.closest('.home-aromas');
      const prev = seccion.querySelector('[data-aromas-prev]');
      const next = seccion.querySelector('[data-aromas-next]');
      const celda = via.querySelector('.home-aromas__celda');
      if (!prev || !next || !celda) return;

      const paso = () => celda.getBoundingClientRect().width + 24;

      const estado = () => {
        const fin = via.scrollWidth - via.clientWidth - 2;
        prev.disabled = via.scrollLeft <= 2;
        next.disabled = via.scrollLeft >= fin;
      };

      prev.addEventListener('click', () => via.scrollBy({ left: -paso() * 2 }));
      next.addEventListener('click', () => via.scrollBy({ left: paso() * 2 }));
      via.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancarAromas());
  } else {
    arrancarAromas();
  }
  document.addEventListener('shopify:section:load', (e) => arrancarAromas(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-destacados"] && !Shopify.designMode) return;
  try {
    
  function arrancarDestacados(raiz) {
    (raiz || document).querySelectorAll('[data-dest-via]').forEach((via) => {
      if (via.dataset.destListo) return;
      via.dataset.destListo = '1';

      const seccion = via.closest('.destacados');
      const prev = seccion.querySelector('[data-dest-prev]');
      const next = seccion.querySelector('[data-dest-next]');
      const celda = via.querySelector('.destacados__celda');
      if (!prev || !next || !celda) return;

      const paso = () => celda.getBoundingClientRect().width + 20;
      const estado = () => {
        const fin = via.scrollWidth - via.clientWidth - 2;
        prev.disabled = via.scrollLeft <= 2;
        next.disabled = via.scrollLeft >= fin;
      };

      prev.addEventListener('click', () => via.scrollBy({ left: -paso() * 2 }));
      next.addEventListener('click', () => via.scrollBy({ left: paso() * 2 }));
      via.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => arrancarDestacados());
  } else {
    arrancarDestacados();
  }
  document.addEventListener('shopify:section:load', (e) => arrancarDestacados(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  /* La cabecera va pasando de una toma a la siguiente.

     Los videos se cargan solo cuando les toca -preload: none-, porque cargar
     tres a la vez en la primera pantalla es justo lo que hace lenta una portada
     con video. */
  (function () {
    var fondo = document.querySelector('[data-fondo]');
    if (!fondo) return;
    var tomas = fondo.querySelectorAll('.home-hero__toma');
    if (tomas.length < 2) return;

    var seccion = fondo.closest('.home-hero');
    var espera = parseInt(seccion && seccion.dataset.segundos, 10) || 7;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducido.matches) return;

    /* Se le pide al siguiente que se vaya cargando mientras se ve el de ahora.
       Van con preload none para no descargarlos todos en la primera pantalla,
       pero sin esto el que entra llega sin un solo fotograma y se queda unos
       segundos en su miniatura antes de arrancar. */
    function prepara(i) {
      var v = tomas[i].querySelector('video');
      if (v && v.preload === 'none') { v.preload = 'auto'; try { v.load(); } catch (e) {} }
    }

    /* SAFARI DEL IPHONE
       Solo deja arrancar un video solo si esta silenciado, y no le basta con
       el atributo muted del HTML: quiere la propiedad puesta en el elemento
       antes de pedirle que se reproduzca. Sin esto el primer video se queda
       parado y iOS dibuja encima su boton de play.

       Se le pone a todos, no solo al primero, porque los demas arrancan a
       mitad de la rotacion y les pasa lo mismo. */
    Array.prototype.forEach.call(tomas, function (t) {
      var v = t.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    });

    var actual = 0;
    var primero = tomas[0].querySelector('video');
    if (primero) {
      var arranque = primero.play();
      if (arranque && arranque.catch) { arranque.catch(function () {}); }
    }
    prepara((actual + 1) % tomas.length);

    function pasa() {
      tomas[actual].classList.remove('is-activa');
      var v = tomas[actual].querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }

      actual = (actual + 1) % tomas.length;
      tomas[actual].classList.add('is-activa');
      var w = tomas[actual].querySelector('video');
      /* play() devuelve una promesa que Chrome rechaza cuando decide pausar el
         vídeo por ahorro de energía -pestaña en segundo plano-. Sin el catch
         sale un error sin capturar en la consola en cada vuelta. */
      if (w) {
        w.currentTime = 0;
        var promesa = w.play();
        if (promesa && promesa.catch) { promesa.catch(function () {}); }
      }

      prepara((actual + 1) % tomas.length);
    }
    window.setInterval(pasa, espera * 1000);

    /* Si el navegador no deja arrancar solo -pasa en moviles con ahorro de
       bateria- el video se queda congelado en el primer fotograma. Como el
       boton de play esta escondido, no habria forma de moverlo. Asi que se
       intenta otra vez en cuanto la persona toca la pantalla, que es cuando
       los navegadores si lo permiten. Una sola vez y se quita el oyente. */
    var reintentar = function () {
      var v = tomas[actual] && tomas[actual].querySelector('video');
      if (v && v.paused) {
        var p = v.play();
        if (p && p.catch) { p.catch(function () {}); }
      }
      document.removeEventListener('touchstart', reintentar);
      document.removeEventListener('click', reintentar);
    };
    document.addEventListener('touchstart', reintentar, { passive: true });
    document.addEventListener('click', reintentar);
  })();

  /* Ajusta la raya de los titulares de la portada a la palabra donde acaban.
     La raya va bajo la caja del titular, y cuando el texto parte en varias
     lineas la caja se queda con el ancho disponible: la raya seguia 200 px mas
     alla de la ultima palabra. En CSS no hay forma de medir la linea mas larga,
     asi que se mide aqui y se le da a la caja esa medida.

     Vive en la portada porque es donde estan estos titulares; los de coleccion
     y producto van en una sola linea y no lo necesitan. */
  (function () {
    var CLASES = ['destacados__titulo', 'home-aromas__titulo', 'recom__titulo',
                  'prox__titulo', 'pro__titulo', 'igt__titulo'];
    var seleccion = CLASES.map(function (c) { return '.' + c; }).join(',');

    function lineas(el) {
      var rango = document.createRange();
      rango.selectNodeContents(el);
      return rango.getClientRects();
    }

    function ajusta() {
      document.querySelectorAll(seleccion).forEach(function (el) {
        el.style.maxInlineSize = '';           // medir sin el ajuste anterior
        var antes = lineas(el);
        var mayor = 0;
        for (var i = 0; i < antes.length; i++) {
          if (antes[i].width > mayor) mayor = antes[i].width;
        }
        if (mayor <= 0) return;

        /* Dos pixeles de holgura: el ancho medido se queda a veces una decima
           corto -letter-spacing y anchos fraccionarios- y el titular partia una
           linea de mas justo al aplicar la medida. */
        el.style.maxInlineSize = Math.ceil(mayor) + 2 + 'px';

        /* Y si aun asi parte mas lineas que antes, se deja como estaba: mejor
           una raya algo larga que un titular descuadrado. */
        if (lineas(el).length > antes.length) el.style.maxInlineSize = '';
      });
    }

    var pendiente;
    function pide() {
      window.clearTimeout(pendiente);
      pendiente = window.setTimeout(ajusta, 120);
    }

    /* Con la tipografia ya cargada: medida antes, las lineas no son las mismas. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(ajusta);
    } else {
      ajusta();
    }
    window.addEventListener('resize', pide, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-cabecera"] && !Shopify.designMode) return;
  try {
    
  /* Carrete de fotos. El desplazamiento lo hace el propio navegador con
     scroll-snap: las flechas solo empujan. Asi funciona igual con el dedo en
     movil y no hay estado que se pueda desincronizar. */
  (function () {
    document.querySelectorAll('[data-carrete]').forEach(function (carrete) {
      var zona = carrete.closest('.pcab__fotos');
      if (!zona) return;
      var tomas = carrete.querySelectorAll('.pcab__toma');
      var cuenta = zona.querySelector('[data-cuenta]');
      var mando = zona.querySelector('.pcab__mando');
      if (tomas.length < 2) {
        if (mando) mando.hidden = true;
        return;
      }

      function paso() {
        /* el ancho real de una diapositiva, no el del carrete: no tienen por
           que coincidir si el hueco esta topado de altura */
        return tomas[0].getBoundingClientRect().width || carrete.clientWidth;
      }
      function actual() {
        return Math.round(carrete.scrollLeft / paso());
      }
      function pinta() {
        if (cuenta) cuenta.textContent = (actual() + 1) + ' / ' + tomas.length;
      }

      zona.querySelectorAll('[data-ir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var destino = actual() + parseInt(b.dataset.ir, 10);
          destino = Math.max(0, Math.min(tomas.length - 1, destino));
          carrete.scrollTo({ left: destino * paso(), behavior: 'smooth' });
        });
      });

      carrete.addEventListener('scroll', function () {
        window.clearTimeout(carrete._t);
        carrete._t = window.setTimeout(pinta, 80);
      }, { passive: true });

      pinta();
    });
  })();

  /* El vídeo se pone en marcha cuando el carrete llega a él.

     Estaba con autoplay apagado y la barra de mandos puesta, esperando a que
     alguien pasara las cuatro fotos y le diera al play. Nadie lo hacía, así que
     el vídeo estaba y a la vez no estaba. Ahora arranca solo al entrar en
     pantalla y se para al salir, que es lo que hacen los de la portada y los de
     Nuestra historia.

     autoplay no vale aquí: el vídeo está en la página desde el principio, solo
     que desplazado fuera del carrete, y arrancaría sin que nadie lo vea. Por lo
     mismo va con preload none y solo se descarga cuando de verdad hace falta. */
  (function () {
    var pelicula = document.querySelector('.pcab__toma--video video');
    if (!pelicula || !('IntersectionObserver' in window)) return;

    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducido.matches) {
      pelicula.controls = true;
      return;
    }

    var vigia = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          var promesa = pelicula.play();
          /* Chrome pausa el vídeo por ahorro de energía cuando la pestaña está
             en segundo plano y rechaza la promesa; sin esto salta un error sin
             capturar en la consola. */
          if (promesa && promesa.catch) { promesa.catch(function () {}); }
        } else {
          try { pelicula.pause(); } catch (err) {}
        }
      });
    }, { threshold: 0.6 });

    vigia.observe(pelicula);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-despiece"] && !Shopify.designMode) return;
  try {
    
  /* El scroll se convierte en un numero de 0 a 1 por pieza y se deja en --q.
     Todo el movimiento lo hace luego el CSS interpolando entre la fila y el
     montaje: aqui no se toca ni una posicion.

     Cada pieza tiene su ventana (data-ini, data-fin) para que la tapa caiga
     primero y el estuche entre despues, en vez de moverse todo a la vez. */
  (function () {
    var secciones = document.querySelectorAll('[data-despiece]');
    if (!secciones.length) return;

    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* En el movil este efecto se ve mal: la animacion depende de medir cuanto
       se ha desplazado la pantalla, y en Safari e iOS la barra de arriba
       aparece y desaparece mientras se hace scroll, cambiando la altura
       disponible en mitad del gesto. El calculo se desincroniza y la pieza
       tiembla o salta en vez de caer suave. En el ordenador esa barra no
       existe y el efecto es estable.

       Por debajo de este ancho se trata igual que "movimiento reducido": la
       pieza se queda quieta en su sitio, el mismo estado abierto que ya se ve
       al cargar la pagina en el ordenador antes de bajar. */
    var movil = window.matchMedia('(max-width: 47.99rem)');
    var pendiente = false;

    function suave(t) {
      /* smoothstep: arranca y frena solo, que es lo que separa una animacion
         de un objeto arrastrado por la rueda del raton */
      return t * t * (3 - 2 * t);
    }

    function avance(sec) {
      /* La escena se queda pegada mientras el carril pasa por debajo, y el
         tramo sobrante del carril es el recorrido de la animacion. Es la unica
         forma de que el montaje dure mas que el propio alto de la escena: sin
         anclarla, todo pasaba en poco mas de una vuelta de rueda.

         (Antes lo descarte creyendo que .page-wrapper recortaba el overflow y
         anulaba el sticky. No lo recorta: lo lei mal.) */
      var carril = sec.querySelector('.despiece__carril');
      var fijo = sec.querySelector('.despiece__fijo');
      if (!carril || !fijo) return 1;
      var caja = carril.getBoundingClientRect();
      var util = caja.height - fijo.offsetHeight;
      if (util <= 0) return 1;
      return Math.min(1, Math.max(0, -caja.top / util));
    }

    function pinta() {
      pendiente = false;
      for (var i = 0; i < secciones.length; i++) {
        var sec = secciones[i];
        var p = (reducido.matches || movil.matches) ? 0 : avance(sec);
        var piezas = sec.querySelectorAll('.despiece__pieza');
        for (var j = 0; j < piezas.length; j++) {
          var pz = piezas[j];
          var ini = parseFloat(pz.dataset.ini) || 0;
          var fin = parseFloat(pz.dataset.fin) || 1;
          var q = fin > ini ? (p - ini) / (fin - ini) : 1;
          q = Math.min(1, Math.max(0, q));
          pz.style.setProperty('--q', suave(q).toFixed(4));
          /* el arco sube y baja: es lo que hace que la tapa parezca caer en
             vez de deslizarse en linea recta */
          pz.style.setProperty('--vuelo', Math.sin(Math.PI * q).toFixed(4));
        }
        sec.style.setProperty('--p', p.toFixed(4));
      }
    }

    function pide() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(pinta);
    }

    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide, { passive: true });
    reducido.addEventListener('change', pide);
    movil.addEventListener('change', pide);
    pinta();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-otros"] && !Shopify.designMode) return;
  try {
    
  /* Las flechas del carrusel de formatos: empujan un ancho de tarjeta. */
  (function () {
    document.querySelectorAll('[data-carro]').forEach(function (carro) {
      var zona = carro.closest('.potros__carro');
      if (!zona) return;
      var primera = carro.querySelector('li');
      zona.querySelectorAll('[data-ir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var paso = primera ? primera.getBoundingClientRect().width + 24 : 200;
          carro.scrollBy({ left: paso * parseInt(b.dataset.ir, 10) * 2, behavior: 'smooth' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
